var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnFr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1084_17230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 2.99062C19.6656 1.67656 17.1734 0.90625 14.5 0.90625C11.8266 0.90625 9.33437 1.67656 7.25 2.99062V25.9641C9.33437 27.2781 11.8266 28.0484 14.5 28.0484C17.1734 28.0484 19.6656 27.2781 21.75 25.9641V2.99062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.75 2.9906V25.964C25.5562 23.6078 28.0938 19.2578 28.0938 14.4547C28.0938 9.65154 25.5562 5.39216 21.75 2.9906ZM7.25 2.9906C3.44375 5.39216 0.90625 9.74216 0.90625 14.5C0.90625 19.2578 3.44375 23.6078 7.25 26.0094V2.9906ZM19.4391 14.3187C19.2578 14.2281 19.2125 14.0469 19.2578 13.9562L19.7109 12.325L18.125 12.6422C18.0797 12.6422 17.8984 12.6422 17.8531 12.325L17.7172 11.7812L16.6297 13.05C16.6297 13.05 15.9047 13.8203 16.1312 12.6422L16.5844 10.15L15.7234 10.6031C15.6781 10.6031 15.4969 10.6484 15.2703 10.1953L14.5 8.60935L13.6844 10.1047C13.4578 10.5578 13.2766 10.5125 13.2313 10.5125L12.3703 10.0594L12.8234 12.5515C13.05 13.7297 12.325 12.9594 12.325 12.9594L11.2375 11.6906L11.1016 12.2344C11.0109 12.5515 10.875 12.5515 10.8297 12.5515L9.24375 12.2344L9.69687 13.8656C9.69687 14.0015 9.69687 14.1375 9.51562 14.2281L9.0625 14.5C9.0625 14.5 10.875 15.95 11.4641 16.4484C11.6 16.539 11.8719 16.8109 11.7812 17.1281L11.5547 17.7625L14.0469 17.4C14.1828 17.4 14.4547 17.4 14.4094 17.8078L14.2734 20.3906H14.7266L14.5906 17.8078C14.5906 17.4 14.8625 17.4 14.9531 17.4L17.4453 17.7625L17.2188 17.1281C17.1281 16.8109 17.4 16.539 17.5359 16.4484C18.125 15.95 19.9375 14.5 19.9375 14.5L19.4391 14.3187Z",
    fill: "#ED4C5C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1084_17230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnFr);
export default __webpack_public_path__ + "static/media/en-fr.de19bccda1a371083a36a1e977e1d251.svg";
export { ForwardRef as ReactComponent };